import cn from 'classnames'
import { HTMLAttributes } from 'react'

import { Tooltip } from 'core-components/library/tooltip/Tooltip'

import { FrequencyFlag } from '../../model/types'

import styles from './FrequentIcon.module.scss'

type Props = HTMLAttributes<HTMLElement> & {
  frequentFlag: string | null
}

export const FrequentIcon = ({ frequentFlag, className, ...props }: Props) => {
  const isFrequent = frequentFlag === FrequencyFlag.Frequent

  const tooltipText = isFrequent ? 'Frequent Buyer' : 'Not a Frequent Buyer'
  const iconMod = isFrequent ? 'hpicon-top-fb' : 'hpicon-top-nfb'

  return (
    <Tooltip tipContent={() => <>{tooltipText}</>}>
      <i
        {...props}
        // 3. Рендерим один раз, просто подставляя нужный модификатор
        className={cn(styles.icon, className, 'hpicon', iconMod)}
      />
    </Tooltip>
  )
}
